import React from 'react';
import { Card, Typography } from 'antd';
import { FileGallery } from '../file/FileGallery';

const { Title } = Typography;

interface EquipmentMediaGalleryProps {
  equipmentId: string;
  editable?: boolean;
}

/**
 * 設備メディアギャラリーコンポーネント
 * 設備に紐づく画像・動画の表示とアップロード機能を提供
 */
export const EquipmentMediaGallery: React.FC<EquipmentMediaGalleryProps> = ({
  equipmentId,
  editable = false,
}) => {
  return (
    <Card
      title={
        <Title level={4} style={{ margin: 0 }}>
          添付ファイル
        </Title>
      }
      style={{ marginTop: 24 }}
    >
      <FileGallery
        entityType="equipment"
        entityId={equipmentId}
        category="media"
        editable={editable}
        maxFiles={20}
        maxSize={10}
        accept="image/*,video/*"
        enableCamera={true}
      />
    </Card>
  );
};
